<template>
  <div class="ELYXFooterCTAShort">
    <div class="ELYXFooterCTAShort--pretext" v-if="pretext">{{ pretext }}</div>
    <div class="ELYXFooterCTAShort--headline">{{ headline }}</div>
    <ELYXButton class="ELYXFooterCTAShort--button" @click="goToLink">{{ buttonText }}</ELYXButton>
  </div>
</template>

<script>
export default {
  components: {
    ELYXButton: () => import("./ELYXButton.vue"),
  },
  props: {
    pretext: {
      type: String,
      default: "",
    },
    headline: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "Join Today",
    },
    link: {
      type: String,
      default: "register",
    },
  },
  methods: {
    goToLink() {
      window.mixpanel.track(`Clicked from ELYXFooterCTAShort to go to ${this.link}`);
      if (this.link.includes("http")) {
        window.open(this.link, "_blank");
      } else {
        this.$router.push({ name: this.link, query: { source: this.link } });
      }
    },
  },
};
</script>

<style>
.ELYXFooterCTAShort {
  padding-top: 10rem;
  padding-bottom: 14rem;
}
.ELYXFooterCTAShort--pretext {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  width: 600px;
  margin-bottom: 25px;
  font-weight: 500;
  font-size: 20px;
  color: #333;
}
.ELYXFooterCTAShort--headline {
  font-size: 45px;
  font-weight: 400;
  text-align: center;
  margin-bottom: 45px;
  max-width: 600px;
  margin-left: auto;
  margin-right: auto;
  line-height: 55px;
}
.ELYXFooterCTAShort--button button {
  font-size: 20px;
  max-width: 220px;
  height: 65px;
}
@media (max-width: 600px) {
  .ELYXFooterCTAShort {
    padding: 5rem 1rem;
    padding-bottom: 7rem;
  }
  .ELYXFooterCTAShort--pretext {
    width: unset;
    margin-top: unset;
  }
  .ELYXFooterCTAShort--headline {
    font-size: 40px;
  }
}
@media (max-width: 375px) {
  .ELYXFooterCTAShort--headline {
    font-size: 35px;
    line-height: 50px;
    margin-bottom: 35px;
  }
}
</style>
